export default "__VITE_ASSET__CJSWp1I6__"